import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useState } from "react";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import lineBreak from "../../../utils/lineBreak";

export default function CardsResponse() {
  const { t } = useTranslation();
  const [jsonFinal, setJsonFinal] = useState<string>("");
  const [title, setTitle] = useState<string>("");

  const [value, setValue] = useState<any>({
    description: "",
  });

  const [values, setValues] = useState<any[]>([]);

  const generate = () => {
    const concat = lineBreak(title);
    values.forEach((item) => {
      if (item.description) {
        item.description = item.description.replaceAll("\\n", "\n");
      }
    });

    const jsonGerado = {
      generic: [
        {
          response_type: "text",
          values: [
            {
              text_expression: {
                concat,
              },
            },
          ],
          selection_policy: "sequential",
        },
        {
          user_defined: {
            type: "cards",
            value: {
              cards: {
                steps: values,
              },
            },
          },
          response_type: "user_defined",
        },
      ],
    };
    setJsonFinal(JSON.stringify(jsonGerado, null, 2));
  };

  const clear = () => {
    setValues([]);
    setValue({
      description: "",
    });
    setJsonFinal("");
    setTitle("");
  };

  return (
    <Grid container>
      <Grid container sx={{ marginBottom: 2 }}>
        <Grid item xs={12}>
          <TextField
            multiline
            rows="4"
            fullWidth
            id="outlined-basic"
            label={t("transformJson.title")}
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ marginBottom: 2 }}>
        <Grid item xs={4}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.description")}
            variant="outlined"
            value={value.description || ""}
            onChange={(e) =>
              setValue({ ...value, description: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={1}>
          <IconButton
            color="primary"
            aria-label="add"
            disabled={value.description !== "" ? false : true}
            onClick={(e) => {
              setValues(value);
              setValues([...values, value]);
              setValue({
                description: "",
              });
            }}
          >
            <AddIcon />
          </IconButton>
        </Grid>
      </Grid>
      {values.map((aux: any, index: number) => {
        return (
          <Grid
            key={`${aux.description || "card"}-${index}`}
            container
            sx={{ marginBottom: 2 }}
          >
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.description")}
                variant="outlined"
                value={aux.description || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].description = e.target.value;
                  setValue(newArr);
                }}
              />
            </Grid>
            <IconButton
              color="primary"
              aria-label="add"
              onClick={(e) => {
                const newArr = [...values];
                newArr.splice(index, 1);
                setValues(newArr);
              }}
            >
              <RemoveIcon />
            </IconButton>
          </Grid>
        );
      })}
      <Grid container spacing={2} sx={{ marginBottom: 1 }}>
        <Grid item>
          <Button
            variant="contained"
            sx={{ marginTop: "8px" }}
            disabled={title === "" || values.length === 0 ? true : false}
            onClick={generate}
          >
            {t("button.Generate")}
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" sx={{ marginTop: "8px" }} onClick={clear}>
            {t("button.Clean")}
          </Button>
        </Grid>
      </Grid>
      <Grid container direction="column">
        <Grid item>
          <pre
            style={{
              wordWrap: "break-word",
              maxWidth: "37rem",
              whiteSpace: "pre-wrap",
            }}
          >
            {jsonFinal}
          </pre>
        </Grid>
        <Grid item>
          {jsonFinal !== "" ? (
            <Button
              disabled={false}
              variant="contained"
              onClick={() => {
                navigator.clipboard.writeText(jsonFinal);
              }}
              startIcon={<ContentCopyIcon />}
            >
              {t("button.Copy")}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
